"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTransfer = exports.getDisplayName = exports.coaIncludedInList = void 0;
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const scheduled_transactions_1 = require("companion-app-components/flux/scheduled-transactions");
function coaIncludedInList(coa, categoriesById, accountsById, stType) {
    switch (coa.type) {
        case chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.CATEGORY: {
            const category = categoriesById.get(coa.id);
            if (category && category.isExcludedFromCategoryList) {
                return false;
            }
            break;
        }
        case chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.BALANCE_ADJUSTMENT: {
            if (stType === scheduled_transactions_1.scheduledTransactionsTypes.STTypeEnum.TRANSFER &&
                chart_of_accounts_1.chartOfAccountsUtils.getBalanceAdjustmentString(coa.id) !== 'Transfer') {
                return false;
            }
            break;
        }
        case chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.UNCATEGORIZED: {
            if (stType === scheduled_transactions_1.scheduledTransactionsTypes.STTypeEnum.INCOME) {
                return false;
            }
            break;
        }
        case chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.ACCOUNT: {
            const account = accountsById.get(coa.id);
            if (account && account.type === 'INVESTMENT') {
                return false;
            }
            break;
        }
        default:
            break;
    }
    return true;
}
exports.coaIncludedInList = coaIncludedInList;
const getDisplayName = (returnString, longCats, node) => {
    if (node) {
        return longCats ? node.fullPathName : node.name;
    }
    return returnString;
};
exports.getDisplayName = getDisplayName;
const isTransfer = (node) => { var _a; return node && ((_a = node === null || node === void 0 ? void 0 : node.coa) === null || _a === void 0 ? void 0 : _a.type) === 'ACCOUNT'; };
exports.isTransfer = isTransfer;
